import { render } from "./StatusPill.vue?vue&type=template&id=668e6700&scoped=true"
import script from "./StatusPill.vue?vue&type=script&lang=js"
export * from "./StatusPill.vue?vue&type=script&lang=js"

import "./StatusPill.vue?vue&type=style&index=0&id=668e6700&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668e6700"]])

export default __exports__